// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as Char123LocaleChar125RouteRouteImport } from './routes/{-$locale}/route'
import { Route as AuthPathnameRouteImport } from './routes/auth.$pathname'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminShopsRouteImport } from './routes/admin/shops'
import { Route as AdminRegionsRouteImport } from './routes/admin/regions'
import { Route as AdminRankingsRouteImport } from './routes/admin/rankings'
import { Route as AdminLanguagesRouteImport } from './routes/admin/languages'
import { Route as AdminCategoriesRouteImport } from './routes/admin/categories'
import { Route as AdminBillingRouteImport } from './routes/admin/billing'
import { Route as Char123LocaleChar125DiscoveryRouteImport } from './routes/{-$locale}/discovery'
import { Route as Char123LocaleChar125AiAssistantRouteImport } from './routes/{-$locale}/ai-assistant'
import { Route as Char123LocaleChar125PublicRouteRouteImport } from './routes/{-$locale}/_public/route'
import { Route as Char123LocaleChar125DevTestGoogleCardRouteImport } from './routes/{-$locale}/_dev.test-google-card'
import { Route as Char123LocaleChar125DevTestAvailabilityCardRouteImport } from './routes/{-$locale}/_dev.test-availability-card'
import { Route as Char123LocaleChar125PublicIndexRouteImport } from './routes/{-$locale}/_public/index'
import { Route as Char123LocaleChar125PublicTermsOfServiceRouteImport } from './routes/{-$locale}/_public/terms-of-service'
import { Route as Char123LocaleChar125PublicSearchRouteImport } from './routes/{-$locale}/_public/search'
import { Route as Char123LocaleChar125PublicRankingsRouteImport } from './routes/{-$locale}/_public/rankings'
import { Route as Char123LocaleChar125PublicPrivacyPolicyRouteImport } from './routes/{-$locale}/_public/privacy-policy'
import { Route as Char123LocaleChar125PublicPricingRouteImport } from './routes/{-$locale}/_public/pricing'
import { Route as Char123LocaleChar125PublicFavoritesRouteImport } from './routes/{-$locale}/_public/favorites'
import { Route as Char123LocaleChar125PublicCategoriesIndexRouteImport } from './routes/{-$locale}/_public/categories.index'
import { Route as Char123LocaleChar125PublicShopsShopIdRouteImport } from './routes/{-$locale}/_public/shops.$shopId'
import { Route as Char123LocaleChar125PublicRegionsRegionIdRouteImport } from './routes/{-$locale}/_public/regions.$regionId'
import { Route as Char123LocaleChar125PublicCategoriesCategoryIdRouteImport } from './routes/{-$locale}/_public/categories.$categoryId'
import { Route as Char123LocaleChar125PublicRankingsIndexRouteImport } from './routes/{-$locale}/_public/rankings/index'
import { Route as Char123LocaleChar125PublicRankingsSnapshotIdRouteImport } from './routes/{-$locale}/_public/rankings/$snapshotId'
import { Route as Char123LocaleChar125PublicRankingsCategoryYearCategorySourceIdRouteImport } from './routes/{-$locale}/_public/rankings/category/$year/$categorySourceId'

const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const Char123LocaleChar125RouteRoute = Char123LocaleChar125RouteRouteImport.update({
            id: '/{-$locale}',path: '/{-$locale}',getParentRoute: () => rootRouteImport
          })
const AuthPathnameRoute = AuthPathnameRouteImport.update({
            id: '/auth/$pathname',path: '/auth/$pathname',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminShopsRoute = AdminShopsRouteImport.update({
            id: '/shops',path: '/shops',getParentRoute: () => AdminRoute
          })
const AdminRegionsRoute = AdminRegionsRouteImport.update({
            id: '/regions',path: '/regions',getParentRoute: () => AdminRoute
          })
const AdminRankingsRoute = AdminRankingsRouteImport.update({
            id: '/rankings',path: '/rankings',getParentRoute: () => AdminRoute
          })
const AdminLanguagesRoute = AdminLanguagesRouteImport.update({
            id: '/languages',path: '/languages',getParentRoute: () => AdminRoute
          })
const AdminCategoriesRoute = AdminCategoriesRouteImport.update({
            id: '/categories',path: '/categories',getParentRoute: () => AdminRoute
          })
const AdminBillingRoute = AdminBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AdminRoute
          })
const Char123LocaleChar125DiscoveryRoute = Char123LocaleChar125DiscoveryRouteImport.update({
            id: '/discovery',path: '/discovery',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125AiAssistantRoute = Char123LocaleChar125AiAssistantRouteImport.update({
            id: '/ai-assistant',path: '/ai-assistant',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125PublicRouteRoute = Char123LocaleChar125PublicRouteRouteImport.update({
            id: '/_public',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125DevTestGoogleCardRoute = Char123LocaleChar125DevTestGoogleCardRouteImport.update({
            id: '/_dev/test-google-card',path: '/test-google-card',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125DevTestAvailabilityCardRoute = Char123LocaleChar125DevTestAvailabilityCardRouteImport.update({
            id: '/_dev/test-availability-card',path: '/test-availability-card',getParentRoute: () => Char123LocaleChar125RouteRoute
          })
const Char123LocaleChar125PublicIndexRoute = Char123LocaleChar125PublicIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => Char123LocaleChar125PublicRouteRoute
          })
const Char123LocaleChar125PublicTermsOfServiceRoute = Char123LocaleChar125PublicTermsOfServiceRouteImport.update({
            id: '/terms-of-service',path: '/terms-of-service',getParentRoute: () => Char123LocaleChar125PublicRouteRoute
          })
const Char123LocaleChar125PublicSearchRoute = Char123LocaleChar125PublicSearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => Char123LocaleChar125PublicRouteRoute
          })
const Char123LocaleChar125PublicRankingsRoute = Char123LocaleChar125PublicRankingsRouteImport.update({
            id: '/rankings',path: '/rankings',getParentRoute: () => Char123LocaleChar125PublicRouteRoute
          })
const Char123LocaleChar125PublicPrivacyPolicyRoute = Char123LocaleChar125PublicPrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => Char123LocaleChar125PublicRouteRoute
          })
const Char123LocaleChar125PublicPricingRoute = Char123LocaleChar125PublicPricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => Char123LocaleChar125PublicRouteRoute
          })
const Char123LocaleChar125PublicFavoritesRoute = Char123LocaleChar125PublicFavoritesRouteImport.update({
            id: '/favorites',path: '/favorites',getParentRoute: () => Char123LocaleChar125PublicRouteRoute
          })
const Char123LocaleChar125PublicCategoriesIndexRoute = Char123LocaleChar125PublicCategoriesIndexRouteImport.update({
            id: '/categories/',path: '/categories/',getParentRoute: () => Char123LocaleChar125PublicRouteRoute
          })
const Char123LocaleChar125PublicShopsShopIdRoute = Char123LocaleChar125PublicShopsShopIdRouteImport.update({
            id: '/shops/$shopId',path: '/shops/$shopId',getParentRoute: () => Char123LocaleChar125PublicRouteRoute
          })
const Char123LocaleChar125PublicRegionsRegionIdRoute = Char123LocaleChar125PublicRegionsRegionIdRouteImport.update({
            id: '/regions/$regionId',path: '/regions/$regionId',getParentRoute: () => Char123LocaleChar125PublicRouteRoute
          })
const Char123LocaleChar125PublicCategoriesCategoryIdRoute = Char123LocaleChar125PublicCategoriesCategoryIdRouteImport.update({
            id: '/categories/$categoryId',path: '/categories/$categoryId',getParentRoute: () => Char123LocaleChar125PublicRouteRoute
          })
const Char123LocaleChar125PublicRankingsIndexRoute = Char123LocaleChar125PublicRankingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => Char123LocaleChar125PublicRankingsRoute
          })
const Char123LocaleChar125PublicRankingsSnapshotIdRoute = Char123LocaleChar125PublicRankingsSnapshotIdRouteImport.update({
            id: '/$snapshotId',path: '/$snapshotId',getParentRoute: () => Char123LocaleChar125PublicRankingsRoute
          })
const Char123LocaleChar125PublicRankingsCategoryYearCategorySourceIdRoute = Char123LocaleChar125PublicRankingsCategoryYearCategorySourceIdRouteImport.update({
            id: '/category/$year/$categorySourceId',path: '/category/$year/$categorySourceId',getParentRoute: () => Char123LocaleChar125PublicRankingsRoute
          })





const Char123LocaleChar125PublicRankingsRouteChildren = {
  Char123LocaleChar125PublicRankingsSnapshotIdRoute: Char123LocaleChar125PublicRankingsSnapshotIdRoute,Char123LocaleChar125PublicRankingsIndexRoute: Char123LocaleChar125PublicRankingsIndexRoute,Char123LocaleChar125PublicRankingsCategoryYearCategorySourceIdRoute: Char123LocaleChar125PublicRankingsCategoryYearCategorySourceIdRoute
}

const Char123LocaleChar125PublicRankingsRouteWithChildren = Char123LocaleChar125PublicRankingsRoute._addFileChildren(Char123LocaleChar125PublicRankingsRouteChildren)



const Char123LocaleChar125PublicRouteRouteChildren = {
  Char123LocaleChar125PublicFavoritesRoute: Char123LocaleChar125PublicFavoritesRoute,Char123LocaleChar125PublicPricingRoute: Char123LocaleChar125PublicPricingRoute,Char123LocaleChar125PublicPrivacyPolicyRoute: Char123LocaleChar125PublicPrivacyPolicyRoute,Char123LocaleChar125PublicRankingsRoute: Char123LocaleChar125PublicRankingsRouteWithChildren,Char123LocaleChar125PublicSearchRoute: Char123LocaleChar125PublicSearchRoute,Char123LocaleChar125PublicTermsOfServiceRoute: Char123LocaleChar125PublicTermsOfServiceRoute,Char123LocaleChar125PublicIndexRoute: Char123LocaleChar125PublicIndexRoute,Char123LocaleChar125PublicCategoriesCategoryIdRoute: Char123LocaleChar125PublicCategoriesCategoryIdRoute,Char123LocaleChar125PublicRegionsRegionIdRoute: Char123LocaleChar125PublicRegionsRegionIdRoute,Char123LocaleChar125PublicShopsShopIdRoute: Char123LocaleChar125PublicShopsShopIdRoute,Char123LocaleChar125PublicCategoriesIndexRoute: Char123LocaleChar125PublicCategoriesIndexRoute
}

const Char123LocaleChar125PublicRouteRouteWithChildren = Char123LocaleChar125PublicRouteRoute._addFileChildren(Char123LocaleChar125PublicRouteRouteChildren)



const Char123LocaleChar125RouteRouteChildren = {
  Char123LocaleChar125PublicRouteRoute: Char123LocaleChar125PublicRouteRouteWithChildren,Char123LocaleChar125AiAssistantRoute: Char123LocaleChar125AiAssistantRoute,Char123LocaleChar125DiscoveryRoute: Char123LocaleChar125DiscoveryRoute,Char123LocaleChar125DevTestAvailabilityCardRoute: Char123LocaleChar125DevTestAvailabilityCardRoute,Char123LocaleChar125DevTestGoogleCardRoute: Char123LocaleChar125DevTestGoogleCardRoute
}

const Char123LocaleChar125RouteRouteWithChildren = Char123LocaleChar125RouteRoute._addFileChildren(Char123LocaleChar125RouteRouteChildren)




const AdminRouteChildren = {
  AdminBillingRoute: AdminBillingRoute,AdminCategoriesRoute: AdminCategoriesRoute,AdminLanguagesRoute: AdminLanguagesRoute,AdminRankingsRoute: AdminRankingsRoute,AdminRegionsRoute: AdminRegionsRoute,AdminShopsRoute: AdminShopsRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren = {
  Char123LocaleChar125RouteRoute: Char123LocaleChar125RouteRouteWithChildren,AdminRoute: AdminRouteWithChildren,DashboardRoute: DashboardRoute,AuthPathnameRoute: AuthPathnameRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)